class SybilProductReviews extends HTMLElement {
  connectedCallback() {
    if (this.observer) return;

    this.syncRatingNumber();
    this.observer = new MutationObserver(() => this.syncRatingNumber());
    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ['data-average-rating'],
      childList: true,
      subtree: true,
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = undefined;
  }

  syncRatingNumber() {
    const widget = this.querySelector('.jdgm-rev-widg');
    const header = widget?.querySelector('.jdgm-rev-widg__header');
    if (!(widget instanceof HTMLElement) || !(header instanceof HTMLElement)) return;

    const averageRating = widget.dataset.averageRating?.trim() ?? '';
    let ratingNumber = header.querySelector('[data-sybil-review-rating-number]');

    if (!(ratingNumber instanceof HTMLElement)) {
      ratingNumber = document.createElement('span');
      ratingNumber.className = 'sybil-product-reviews__rating-number';
      ratingNumber.dataset.sybilReviewRatingNumber = '';
      ratingNumber.setAttribute('aria-hidden', 'true');
      header.prepend(ratingNumber);
    }

    if (ratingNumber.textContent !== averageRating) ratingNumber.textContent = averageRating;
    const shouldHide = !averageRating;
    if (ratingNumber.hidden !== shouldHide) ratingNumber.hidden = shouldHide;
  }
}

if (!customElements.get('sybil-product-reviews')) {
  customElements.define('sybil-product-reviews', SybilProductReviews);
}
